import React, { useContext, useEffect } from "react";
import Spinner from "../Layout/Spinner";
import {Url} from "../../actions/config"

import "react-responsive-carousel/lib/styles/carousel.css";
import { Carousel } from "react-responsive-carousel";

const Rses = ({ pictures }) => {
  return (
    <section id="gallery"  style={{ direction: "ltr" }}>
      <div>
        {pictures && pictures !== "" ? (
          <Carousel>
            {pictures.map((pic, index) => (
              <div>
                <img src={`${Url}/${pic}`} />
              </div>
            ))}
          </Carousel>
        ) : (
          <Spinner />
        )}
      </div>
    </section>
  );
};

export default Rses;
